export default "__VITE_ASSET__389b5139__"